type AudioContextCtor = typeof AudioContext;

function getAudioContextCtor(): AudioContextCtor | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: AudioContextCtor })
      .webkitAudioContext
  );
}

export function playAlertSound(): void {
  const AudioCtx = getAudioContextCtor();
  if (!AudioCtx) {
    return;
  }

  try {
    const ctx = new AudioCtx();
    const start = ctx.currentTime;

    const beep = (offset: number, frequency: number, duration: number) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0.0001, start + offset);
      gain.gain.exponentialRampToValueAtTime(0.3, start + offset + 0.02);
      gain.gain.exponentialRampToValueAtTime(
        0.0001,
        start + offset + duration
      );
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.start(start + offset);
      oscillator.stop(start + offset + duration);
    };

    beep(0, 880, 0.25);
    beep(0.3, 1046.5, 0.3);

    // Release the audio context once the chime has finished.
    window.setTimeout(() => {
      ctx.close?.();
    }, 900);
  } catch {
    // Ignore — audio is a non-critical enhancement.
  }
}
